import { api } from "./api";

/**
 * Re-add every line of a past order into the current cart.
 * Fetches the latest product doc for each item so pricing reflects today's catalogue.
 * Skips items whose product was removed or is out of stock (returned in `skipped`).
 */
export async function reorderIntoCart(order, addItem) {
  const added = [];
  const skipped = [];
  for (const it of order.items || []) {
    try {
      const { data: p } = await api.get(`/products/${it.product_id}`);
      if (!p || p.in_stock === false) {
        skipped.push({ name: it.name, reason: "unavailable" });
        continue;
      }
      addItem(p, it.pack_size, it.quantity);
      added.push(it.name);
    } catch {
      skipped.push({ name: it.name, reason: "removed" });
    }
  }
  return { added, skipped };
}
